// src/pages/locations/components/form/useLeaveConfirm.tsx
import React from "react";

import ConfirmDialog from "@/components/shared/ui/ConfirmDialog";

/**
 * Guards Cancel when the form has unsaved edits, so a stray click cannot throw
 * away typed input. A clean form leaves immediately — no pointless prompt.
 */
export function useLeaveConfirm(onLeave: () => void) {
  const [open, setOpen] = React.useState(false);

  const requestCancel = React.useCallback(
    (isDirty: boolean) => {
      if (isDirty) {
        setOpen(true);
        return;
      }
      onLeave();
    },
    [onLeave]
  );

  const dialog = (
    <ConfirmDialog
      open={open}
      title="Discard changes?"
      message="Your edits on this page have not been saved. Leaving now discards them."
      confirmText="Discard changes"
      cancelText="Keep editing"
      onCancel={() => setOpen(false)}
      onConfirm={() => {
        setOpen(false);
        onLeave();
      }}
    />
  );

  return { requestCancel, dialog };
}
